import React, { FC } from "react"

import { px, useMantineTheme } from "@mantine/core"
import { IconCloudUpload } from "@tabler/icons-react"

import ChartCard from "../../../analytics/components/chart-card/ChartCard"
import { useHealth } from "../../../../contexts/health-context"
import { useLanguage } from "../../../../contexts/language-context"

const DeviceSyncChart: FC = () => {
    const healthContext = useHealth()
    const { L } = useLanguage()
    const theme = useMantineTheme()
    const health = healthContext.data.find(event => event.id === "latest")
    const toUpload = health?.synced[0] || 0
    const uploaded = health?.synced[1] || 0

    return (
        <ChartCard
            label={L("Uploaded Files")}
            option={{
                series: {
                    type: "pie",
                    name: L("Storage"),
                    radius: ["50%", "90%"],
                    top: px("1.5rem"),
                    bottom: px("1.5rem"),
                    itemStyle: {
                        borderRadius: px("0.5rem"),
                        borderColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0],
                        borderWidth: 2,
                    },
                    label: {
                        color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
                        fontSize: theme.fontSizes.sm,
                        overflow: "break",
                        bleedMargin: 0
                    },
                    labelLine: {
                        show: true,
                        smooth: true,
                    },
                    emphasis: {
                        disabled: true
                    },
                    cursor: "default",
                    data: [
                        {
                            value: uploaded,
                            name: `${L('Uploaded')} (${uploaded})`,
                            itemStyle: {color: theme.fn.darken(theme.colors.green[2], 0.50) }
                        },
                        {
                            value: toUpload,
                            name: `${L('To upload')} (${toUpload})`,
                            itemStyle: {color:theme.fn.darken(theme.colors.orange[3], 0.45)}
                        }
                    ],
                }
            }}
            icon={IconCloudUpload}
        />
    )
}

export default DeviceSyncChart
